// extracted by mini-css-extract-plugin
export default {"container":"order-details_container__Ecr7y"};